import { css } from '@emotion/react';

export const styles = {
    loaderWrapper: css({
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }),
};
